/*
  Storie decorative shapes appear with a short motion the first time they come into view.
  The motion itself is in storie-brand.css; this script only adds .is-visible, 80ms apart within a batch.
*/
(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach((entry, index) => {
          entry.target.style.transitionDelay = `${index * 80}ms`;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  const watch = () => document.querySelectorAll('.storie-decor:not(.is-visible)').forEach((shape) => observer.observe(shape));

  watch();
  document.addEventListener('shopify:section:load', watch);
  document.addEventListener('shopify:block:select', watch);
})();
